import { defineMessages, useIntl } from 'react-intl';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

export const i18n: {
	noEditAccessFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noEditAccessFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noEditAccessFlagTitle: {
		id: 'edit-features.no-edit-access-flag.title',
		defaultMessage: 'This shortcut requires edit access',
		description:
			'Title for the flag that displays when user tries to edit the page without edit access',
	},
	noEditAccessFlagDescription: {
		id: 'edit-features.no-edit-access-flag.description',
		// oxlint-disable-next-line eslint-core/no-restricted-syntax
		defaultMessage: "To use this keyboard shortcut, you'll need edit access to this content.",
		description: 'This message appears when user tries to edit the page without edit access',
	},
});

export const useNoEditAccessFlag = (
	flags: FlagsStateContainer,
): {
	showNoEditAccessFlag: () => void;
} => {
	const intl = useIntl();

	const showNoEditAccessFlag = (): void => {
		void flags.showFlag({
			id: 'live-pages-mode-flag',
			title: intl.formatMessage(i18n.noEditAccessFlagTitle),
			description: intl.formatMessage(i18n.noEditAccessFlagDescription),
			close: 'auto',
		});
	};

	return { showNoEditAccessFlag };
};
